export default {
	global: {
		reinitialize: 'reinitialize',
		recalculate: 'recalculate',
	},
	layout: {
		change: 'layout-change',
		breakpoints_ready: 'layout-breakpoints-ready',
	},
	filter: {
		request: 'filter-change-request',
		start: 'filter-change-start',
		end: 'filter-change-end',
		update_field_names: 'filter-update-field-names',
	},
	expandable: {
		toggle_start: 'expandable-toggle-start',
		toggle_end: 'expandable-toggle-end',
	},
	reveal: {
		start: 'reveal-start',
		end: 'reveal-end',
	},
	icon: {
		draw_complete: 'icon-draw-complete',
	},
	scroll_lock: {
		enter: 'scroll-lock-enter',
		leave: 'scroll-lock-leave',
	},
	uikit: {
		before_show: 'beforeshow',
		show: 'show',
		shown: 'shown',
		before_hide: 'beforehide',
		hide: 'hide',
		hidden: 'hidden',
		show_slide: 'itemshow',
		show_slide_done: 'itemshown',
	},
};
